import React, { useState, useEffect } from 'react';
import { Timeline, TimelineEvent } from 'react-event-timeline';
import { ListGroup, ListGroupItem, Button } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import moment from 'moment';

function EventTimeLine(props) {
  const [data, setData] = useState([]);

  function evaluate() {
    if (data.length > 0) {
      return data;
    }
    return props.timelineData;
  }

  function evalEventIcon(isCompleted) {
    if (isCompleted) {
      return <i className="fa fa-check-circle" style={{ fontSize: 20 }} />;
    } else if (isCompleted === undefined) {
      return <i className="fa fa-user-circle" style={{ fontSize: 20 }} />;
    } else if (!isCompleted) {
      return <i className="fa fa-times-circle" style={{ fontSize: 20 }} />;
    }
  }

  // eslint-disable-next-line consistent-return
  function evalIconColor(isCompleted) {
    if (isCompleted) {
      return '#6fba1c';
    } else if (isCompleted === undefined) {
      return '#000';
    } else if (!isCompleted) {
      return '#f34349';
    }
  }

  return (
    <Timeline>
      {props.timelineData
        ? evaluate().map(tlObj => (
          <TimelineEvent
            key={tlObj.timestamp}
            title={tlObj.name}
            createdAt={
                tlObj.timestamp
                  ? moment(tlObj.timestamp).format('MM/DD/YYYY hh:mm')
                  : 'No date available'
              }
            icon={evalEventIcon(tlObj.isCompleted)}
            iconColor={evalIconColor(tlObj.isCompleted)}
            onIconClick={() => {
                if (tlObj.interactionData) {
                  setData(tlObj.interactionData);
                }
              }}
            bubbleStyle={{ backgroundColor: '#fff' }}
            buttons={
                data.length > 0 ? (
                  <i
                    className="fa fa-arrow-circle-left"
                    aria-hidden="true"
                    onClick={() => setData([])}
                    style={{ fontSize: 20, cursor: 'pointer' }}
                  />
                ) : null
              }
            style={{ fontSize: 15 }}
            subtitle={
                tlObj.interactionData && tlObj.interactionData.length > 0
                  ? '✔ Click icon to see more data'
                  : null
              }
          >
            <ListGroup>
              {tlObj.statistics && !isEmpty(tlObj.statistics)
                  ? Object.keys(tlObj.statistics).map((statKey, i) => (
                    <ListGroupItem key={i}>{`${statKey} : ${
                        statKey === 'timeSpent'
                          ? moment
                              .duration(tlObj.statistics[statKey], 'seconds')
                              .humanize()
                          : tlObj.statistics[statKey]
                      }`}
                    </ListGroupItem>
                    ))
                  : 'No statistics available'}
            </ListGroup>
          </TimelineEvent>
          ))
        : null}
    </Timeline>
  );
}

EventTimeLine.propTypes = {
  timelineData: PropTypes.array
};

export default EventTimeLine;
